export default __webpack_public_path__ + "img/component-btn-pink.124c5a52.png";